import { render, staticRenderFns } from "./CustomerAccountsContainer.vue?vue&type=template&id=5365db31&scoped=true&"
import script from "./CustomerAccountsContainer.vue?vue&type=script&lang=js&"
export * from "./CustomerAccountsContainer.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAccountsContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CustomerAccountsContainer.vue?vue&type=style&index=1&id=5365db31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5365db31",
  null
  
)

export default component.exports